import { useState, useEffect } from "react";

import axios from "axios";

import { getErrorMessage, checkInputErrors } from '@/utils/Errors';

import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import Dropdown from '@/components/Dropdown';
import Input from '@/components/Input';

import {
    Send as SendIcon,
    Close as CancelIcon,
    ThumbUp as AcceptIcon,
    ThumbDown as RejectIcon,
} from '@mui/icons-material';

export default function ResourceBookingModal({t, open, setOpen, fullScreen, resource, plans, setChanged, user, token, apiUrl, 
    language, sendMessage, handleLogin, manage}){

	const { sxDialogMinHeight } = getModalStyle();

    const handleClose = () => {
        setOpen(false); 
    }

    const [ errors, setErrors ] = useState(null);
    const [ data, setData ] = useState({ 
        plan: null,       
        details: ''
    });

    const resetData = () => {
        setData({
            plan: null,
            details: ''
        });
    }

    useEffect(() => {
        if(open){
            resetData();
            setErrors(null);
        }
    },[open]);

    const handleInput = (e) => {
        
        var name = e.target.name;
        var value = e.target.value;

        var newData = {...data};
        newData[name] = value;
        setData(newData);
    };

    // to manage the plans
    const handlePlan = (newItem) => {
        var newData = {...data};
        newData.plan = newItem;
        setData(newData);
    }

    const handleSubmit = (accept = null) => {
        
        let fieldsNotEmpty;
        if(manage || resource?.situation?.booking){
            // remove booking
            fieldsNotEmpty = [];
        }
        else{            
            // make booking
            fieldsNotEmpty = ['plan'];
        }

        setErrors(null);
        const errorsCheck = checkInputErrors(data,fieldsNotEmpty);

        if(Object.keys(errorsCheck).length === 0){

            // if on booking, do the opposite
            let apiPath;
            if(manage){
                // accept or reject booking
                if(accept){                    
                    // set rental
                    apiPath = '/resource_rental/set';
                }
                else{
                    // remove booking
                    apiPath = '/resource_rental/booking/remove';
                }
            }
            else{
                if(resource?.situation?.booking){
                    apiPath = '/resource_rental/booking/remove';
                }
                else{
                    apiPath = '/resource_rental/booking/set';
                }
            }

            const configApi = {
                headers: { Authorization: `Bearer ${token}` } 
            };          

            const send = {
                language: language,
                companyuser: user?.company,
                resource: resource?.id                
            };

            if(manage){          

                send.plan = resource?.situation?.event?.plan?.id;

                if(accept){                
                    send.observations = data?.details;
                }
                else{
                    send.details = data?.details;
                }
            }
            else{   

                send.details = data?.details;

                if(resource?.situation?.booking){
                    // if removing booking or manager reviewing booking
                    send.plan = resource?.situation?.event?.plan?.id;
                }
                else{
                    // if booking
                    send.plan = data?.plan?.id;
                }
            }

            // if manager and accepting, send responsible
            // responsible is the user who booked
            if(manage && accept){
                send.responsible = resource?.situation?.event?.user?.id;
            }

            var errorMessage = t('resource_rentals.booking.error');
            
            const url = apiUrl+apiPath;
            
            axios.post(url,send,configApi)
            .then(function (response) {

                if(response?.data){
              
                    const responseData = response.data;                

                    // if result is ok (1)
                    if(responseData?.result){
                        // the opposite
                        let status;
                        if(manage){
                            status = accept ? 'review.accepted' : 'review.rejected';
                        }
                        else{
                            status = resource?.situation?.booking ? 'out.status' : 'in.status';
                        }
                        sendMessage(t('resource_rentals.booking.'+status),resource?.situation?.booking ? 'success' : 'success');
                        
                        if(responseData?.data?.reload){
                            window.location.reload();
                        }
                        else{           
                            const newResource = responseData?.data?.resource;
                            setChanged(newResource);
                            setOpen(false);
                        }
                    } 
                    else{
                        if(responseData?.status && responseData.status === 401){
                            handleLogin();                        
                        }
                        else{
                            // check error message
                            if(responseData?.data?.error){
                                
                                errorMessage = t('resource_rentals.booking.errors.'+responseData?.data?.error);                                

                                // if error and resource, refresh the data
                                if(responseData?.data?.resource){
                                    setChanged(responseData?.data?.resource);
                                    setOpen(false);
                                }
                            }
                            
                            sendMessage(errorMessage,'error');
                        }                        
                    }
                }
                else{                
                    sendMessage(errorMessage,'error');                    
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();                        
                }
                else{                        
                    sendMessage(errorMessage,'error');
                }
            });
        }
        else{            
            const errorMessage = getErrorMessage(t,'resource_rentals.booking',errorsCheck);
            setErrors(errorsCheck);
            sendMessage(errorMessage,'error');
        }
    }

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialogMinHeight}
            onClose={handleClose}
            open={open}
            fullWidth={true}            
        >                        
        	<DialogTitle className='modal-title'>
                {resource?.name}
            </DialogTitle>            
            <DialogContent className='modal-content text-center'>
                <div className='mb-4'>
                    {
                        manage ?
                            t('resource_rentals.booking.review.title')
                        :
                            resource?.situation?.booking ? 
                                t('resource_rentals.booking.out.title')
                            :
                                t('resource_rentals.booking.in.title')
                    }                    
                </div>
                <div className='mb-4'>
                {
                    (manage || resource?.situation?.booking) ?
                        <div className='font-bold border app-border-color-gradient rounded p-2 app-bg-gradient '>
                            <div className='border-b app-border-color-gradient text-center mb-2'>
                                {t('resource_rentals.booking.fields.plan')+' '+t('resource_rentals.booking.plan.out')}
                            </div>
                            <div className='text-center'>
                            {
                                resource?.situation?.location && resource?.situation?.location?.length > 0 ?
                                    <a href={resource?.situation.location} target='_blank'>{resource?.situation?.event?.plan?.name}</a>
                                :
                                    resource?.situation?.event?.plan?.name
                            }
                            </div>
                        </div>
                    :
                        <Dropdown                    
                            type='search'
                            name='plan'
                            value={data.plan}
                            placeholder={t('resource_rentals.booking.fields.plan')}
                            options={plans}
                            handleDropdown={handlePlan}
                            error={errors && errors?.plan ? t('resource_rentals.booking.errors.'+errors.plan) : ''}
                        />                    
                }
                </div>
                {
                    manage &&
                    <>
                    {
                        resource?.situation?.event?.user?.name && resource?.situation?.event?.user?.name?.length > 0 &&
                        <div className='border app-border-color-gradient rounded p-2 mb-4'>
                            <div className='font-bold border-b app-border-color-gradient text-center mb-2'>
                                {t('resource_rentals.booking.fields.user')}
                            </div>
                            <div className='text-center'>
                                {resource?.situation?.event?.user?.name}
                            </div>
                        </div>
                    }
                    {
                        resource?.situation?.event?.description && resource?.situation?.event?.description?.length > 0 &&
                        <div className='border app-border-color-gradient rounded p-2 mb-4'>
                            <div className='font-bold border-b app-border-color-gradient text-center mb-2'>
                                {t('resource_rentals.booking.fields.description')}
                            </div>
                            <div className='text-center'>
                                {resource?.situation?.event?.description}
                            </div>
                        </div>
                    }
                    </>
                }
                <div className='mb-4'>
                    <Input                      
                        name="details"
                        type="multiline"
                        rows={6}
                        value={data.details}                      
                        placeholder={t('resource_rentals.booking.fields.details')}
                        onChange={handleInput}
                        error={errors && errors?.details ? t('resource_rentals.booking.errors.'+errors.details) : ''}                        
                    />
                </div>                
            </DialogContent>  
            {
                manage ?            
                    <div className="modal-buttons">
                        <div className='mr-1'>
                            <AcceptIcon className='action-button-modal text-green-800' onClick={() => handleSubmit(true)}/>
                        </div>                                
                        <div className='mr-1'>
                            <RejectIcon className='action-button-modal text-red-800' onClick={() => handleSubmit(false)}/>
                        </div>
                        <div className='mr-1'>
                            <CancelIcon className='action-button-modal text-black' onClick={handleClose}/>
                        </div>
                    </div>        
                :
                    <div className="modal-buttons">
                        <div className='mr-1'>
                            <SendIcon className='action-button-modal text-green-800' onClick={handleSubmit}/>
                        </div>                                
                        <div className='mr-1'>
                            <CancelIcon className='action-button-modal text-red-800' onClick={handleClose}/>
                        </div>
                    </div>        
            }
        </Dialog>
  );
}